export function isString(v: any): boolean {
  return typeof v === 'string';
}
